import { render } from "./EmailVerificationComponent.vue?vue&type=template&id=47448f15"
import script from "./EmailVerificationComponent.vue?vue&type=script&lang=js"
export * from "./EmailVerificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__